<template>
  <AlertModal
    v-bind="$attrs"
    :value="value"
    @alert-modal-confirm="$emit('alert-modal-confirm')"
    @alert-modal-cancel="$emit('alert-modal-cancel')"
  >
    <template #text>
      <div class="modal-content">
        <slot>
          Caso você já tenha um desconto exclusivo para o mesmo hotel e período
          selecionado, será considerado apenas o maior desconto. Revise os
          períodos e a seleção de hotéis antes de salvar.
        </slot>
      </div>
    </template>
  </AlertModal>
</template>

<script>
import AlertModal from '@solucoes/components-lib-tmp/src/components/patterns/AlertModal'

export default {
  name: 'SaveAlertModal',

  components: {
    AlertModal
  },

  props: {
    value: Boolean
  }
}
</script>

<style lang="scss" scoped>
.modal-content {
  max-width: 328px;
  margin: 0 auto;
}
</style>
